module.exports = __webpack_public_path__ + "img/AUTO.d7d491a0.svg";